export const Intro = () => {
  return (
    <div className='flex flex-col items-center text-center'>
      <h1 className='text-lg md:text-xl lg:text-2xl font-bold text-[#001A3D] tracking-wide'>
        Find a lawyer ready to help you.
      </h1>
      <p className='text-sm md:text-base font-thin pt-4'>
        Look at your options and choose the right lawyer every time
      </p>
    </div>
  )
}
